import {Box, Chip, FormControl, InputLabel, Modal, OutlinedInput, TextField} from '@mui/material';
import React, {useEffect, useState} from 'react';
import TopBar from "../../components/Layout/TopBar";
import MyButton from "../../components/Layout/MyButton";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {URL_API} from "../../utils/globalConfig";
import {logError} from "../../components/Utils/FormatData";
import axios from "axios";
import {ClipLoader} from "react-spinners";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useAlert} from "react-alert";
import {Editor} from 'react-draft-wysiwyg';
import {convertToRaw, EditorState} from 'draft-js';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import MySelect from "../../components/Layout/MySelect";
import draftToHtml from 'draftjs-to-html';

const css = {
	container: {height: '90%', width: '90%', backgroundColor: 'white', borderRadius: '5px'},
	fullRow: {height: '100%', width: '100%', alignItems: 'center'},
	row: {height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal', flexWrap: 'nowrap'},
	rowValidation: {height: '60px', flexDirection: 'column', justifyContent: 'normal', alignItems: 'flex-end'},
	wysiwyg: {margin: '20px', height: '300px', border: '1px solid #c4c4c4', padding: '20px', borderRadius: '4px'}
}

const ModalSendMessage = (props) => {
	const {openModal, setOpenModal, color, user} = props;
	const alert = useAlert();
	const [isLoading, setIsLoading] = useState(false);
	const [requestsPass, setRequestsPass] = useState([]);
	const [recipients, setRecipients] = useState([]);
	const [message, setMessage] = useState({requestPass: null, recipients: [], title: ""})
	const [editorState, setEditorState] = useState(EditorState.createEmpty());

	//#region useEffect

	useEffect(() => {
		if (openModal) {
			callApis();
		}
	}, [openModal]);

	//#endregion

	//#region Functions

	const handleCloseModal = () => {
		setIsLoading(false);
		setRequestsPass([]);
		setRecipients([]);
		setMessage({requestPass: null, recipients: [], title: ""});
		setEditorState(EditorState.createEmpty());
		setOpenModal(false);
	};
	const handleChangeRecipients = (event) => {
		const {target: {value}} = event;
		setMessage({...message, recipients: typeof value === 'string' ? value.split(',') : value});
	};
	const handleChangeTitle = (event) => {
		setMessage({...message, title: event.target.value});
	};
	const validForm = () => {

		if (message.recipients.length === 0) {
			alert.removeAll();
			alert.error("Vous devez sélectionner au moins un destinataire avant de continuer");
			return false;
		}

		if (message.title === "") {
			alert.removeAll();
			alert.error("Vous devez renseigner un titre avant de continuer");
			return false;
		}

		if (message.content === "") {
			alert.removeAll();
			alert.error("Vous devez renseigner un contenu avant de continuer");
			return false;
		}

		return true;
	};
	const sendMessage = () => {
		if (validForm()) {
			axios({method: 'post', url: URL_API + '/messagerie/envoi-message', data: formatMessage()})
				.then(() => {
					alert.removeAll();
					alert.success("Le message a été envoyé avec succés");
					handleCloseModal();
				})
				.catch((err) => {
					logError(alert, err);
				});
		}
	};
	const formatMessage = () => {
		return {
			expediteur: user.user_id,
			destinataires: message.recipients,
			numDossier: message.requestPass,
			title: message.title,
			message: draftToHtml(convertToRaw(editorState.getCurrentContent())),
			channelType: "MESSAGERIE"
		}
	}

	//#endregion

	//#region API

	const callApis = () => {
		setIsLoading(true);

		const promiseRequestPassList = axios({method: 'get', url: URL_API + '/demande-passage/liste-dossiers'});
		const promiseRecipientsList = axios({method: 'get', url: URL_API + '/utilisateur/liste', params: {deleted: 'false'}});

		Promise.all([promiseRequestPassList, promiseRecipientsList])
			.then((values) => {
				setRequestsPass(values[0].data);
				setRecipients(values[1].data);
				setIsLoading(false);
			})
			.catch((err) => {
				logError(alert, err);
			});
	}

	//#endregion

	//#region Render

	return (
		<>
			<Modal open={openModal} style={{display: 'flex'}} disableEscapeKeyDown={true}>
				<div className='modal'>
					<div style={css.container}>
						<TopBar title='Nouveau message' className='topbar-contenu' color={color}
										buttons={
											<div className='topbar-buttons'>
												<MyButton onClick={() => handleCloseModal()} label="Fermer" icon={faXmark}/>
											</div>
										}
						/>

						{
							isLoading &&
							<div className='row' style={css.fullRow}>
								<ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
							</div>
						}

						{
							!isLoading &&
							<>
								<div className='row' style={css.row}>
									<FormControl>
										<InputLabel>Liste des destinataires</InputLabel>
										<Select
											multiple
											value={message.recipients}
											onChange={handleChangeRecipients}
											input={<OutlinedInput label="Chip"/>}
											renderValue={(selected) => (<Box>{selected.map((value) => (<Chip key={value} label={value}/>))}</Box>)}
										>
											{recipients.map((d) => (<MenuItem key={d.user_id} value={d.login}>{d.login}</MenuItem>))}
										</Select>
									</FormControl>

									<TextField label="Titre" variant="outlined" value={message.title} onChange={handleChangeTitle} required/>
									<div style={css.wysiwyg}>
										<Editor
											editorState={editorState}
											wrapperClassName="demo-wrapper"
											editorClassName="demo-editor"
											onEditorStateChange={setEditorState}
											editorStyle={{height: '250px'}}
										/>
									</div>
									<MySelect name={"listeDemandePassage"} label={"N° Demande de passage"}
														datas={requestsPass}
														disableClass={true}
														displayLabel={true}
														firstValue={{key: "", value: "Choisissez une demande de passage"}}
														value={message.requestPass ? message.requestPass : undefined}
														style={{width: "300px"}}
														handleChange={(e) => setMessage({...message, requestPass: e.target.value})}
									/>
								</div>

								<div className="row" style={css.rowValidation}>
									<MyButton onClick={() => sendMessage()} style="buttonValidation" label="Valider l'envoi du message"/>
								</div>
							</>
						}

					</div>
				</div>
			</Modal>
		</>
	);

	//#endregion

};

export default ModalSendMessage;
